import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Home Sliders — owner-only control of the two image strips at the bottom of
// the MOBILE home page: "Our Casino" and "New Games".
const homeSliderService = {
  list: async () => {
    const response = await api.get(API_ENDPOINTS.HOME_SLIDER.LIST)
    return response.data
  },
  create: async (data) => {
    const response = await api.post(API_ENDPOINTS.HOME_SLIDER.CREATE, data)
    return response.data
  },
  // title, route, img and enabled are writable; section is identity and fixed.
  update: async (id, data) => {
    const response = await api.put(`${API_ENDPOINTS.HOME_SLIDER.UPDATE}/${id}`, data)
    return response.data
  },
  remove: async (id) => {
    const response = await api.delete(`${API_ENDPOINTS.HOME_SLIDER.DELETE}/${id}`)
    return response.data
  },
  // Full id list of ONE section, first-to-last.
  reorder: async (section, order) => {
    const response = await api.put(API_ENDPOINTS.HOME_SLIDER.REORDER, { section, order })
    return response.data
  },
  // Multipart upload — the server (multer, memory) answers with a base64
  // dataUrl ready to preview and save onto a slider row.
  uploadImage: async (file) => {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(API_ENDPOINTS.HOME_SLIDER.UPLOAD, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },
}

export default homeSliderService
